import { DriveFileMoveOutlined } from "@mui/icons-material";

export const SideNavbarItems = [
    {
        id:"1",
        title: "Selection",
        icon: <DriveFileMoveOutlined fontSize={"small"} />
    }
]